import { IShipTpEvent } from './TransportPlanEvent'

export const PDAD_CARGO_READY = 'cargoReady'
export const PDAD_PICKUP = 'pickup'
const PDAD_DPR = 'dpr'
export const PDAD_DEPARTURE = 'departure'
export const PDAD_TSP1 = 'tsp1'
export const PDAD_TSP2 = 'tsp2'
export const PDAD_TSP3 = 'tsp3'
export const PDAD_TSP4 = 'tsp4'
export const PDAD_ARRIVAL = 'arrival'
export const PDAD_CGOMD = 'cgomd'
export const PDAD_CGOMO = 'cgomo'
export const PDAD_DELIVERY = 'delivery'
type TPdadCargoReady = typeof PDAD_CARGO_READY
type TPdadPickup = typeof PDAD_PICKUP
type TPdadDpr = typeof PDAD_DPR
type TPdadDeparture = typeof PDAD_DEPARTURE
type TPdadTsp1 = typeof PDAD_TSP1
type TPdadTsp2 = typeof PDAD_TSP2
type TPdadTsp3 = typeof PDAD_TSP3
type TPdadTsp4 = typeof PDAD_TSP4
type TPdadArrival = typeof PDAD_ARRIVAL
type TPdadCgomo = typeof PDAD_CGOMO
type TPdadCgomd = typeof PDAD_CGOMD
type TPdadDelivery = typeof PDAD_DELIVERY

export type TPdadType =
  | TPdadCargoReady
  | TPdadPickup
  | TPdadDpr
  | TPdadDeparture
  | TPdadTsp1
  | TPdadTsp2
  | TPdadTsp3
  | TPdadTsp4
  | TPdadArrival
  | TPdadCgomo
  | TPdadCgomd
  | TPdadCgomo
  | TPdadDelivery

export type TPurePdadType =
  | TPdadCargoReady
  | TPdadPickup
  | TPdadDeparture
  | TPdadArrival
  | TPdadCgomo
  | TPdadCgomd
  | TPdadDelivery

export const PdadStepsSequence: TPdadType[] = [
  PDAD_CARGO_READY,
  PDAD_PICKUP,
  PDAD_CGOMO,
  PDAD_DPR,
  PDAD_DEPARTURE,
  PDAD_TSP1,
  PDAD_TSP2,
  PDAD_TSP3,
  PDAD_TSP4,
  PDAD_ARRIVAL,
  PDAD_CGOMD,
  PDAD_DELIVERY,
]

export interface IPdadItem {
  pdadType: TPdadType
  event: IShipTpEvent
  progress: number
  isProgress: boolean
  passedActual: boolean
  allowShowOnStep: boolean
  durationDays?: number
  transporter?: string // vessel name, flight number
}

export interface IPdadItemInit {
  pdadType: TPdadType
  event: IShipTpEvent
}
